import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EntryGroupComponent} from './entry-group.component';
import {StoreModule} from '@ngrx/store';
import {termsAndConditionsReducer} from '@app/cart/store/reducers/terms-conditions.reducer';
import {EffectsModule} from '@ngrx/effects';
import {TermsConditionsEffects} from '@app/cart/store/effects/terms-conditions.effects';
import {termsAndConditionsFeatureKey} from '@app/cart/store/selectors/terms-conditions.selectors';
import {GroupSkipDirective} from '@dcp/accessibility';

@NgModule({
  exports: [EntryGroupComponent],
  imports: [
    CommonModule,
    GroupSkipDirective,
    StoreModule.forFeature(termsAndConditionsFeatureKey, termsAndConditionsReducer),
    EffectsModule.forFeature([TermsConditionsEffects]),
    EntryGroupComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EntryGroupModule {}
